import { useState } from "react";
import StepOne from "../components/SymptomChecker/StepOne";
import StepTwo from "../components/SymptomChecker/StepTwo";
import ResultsDetail from "../components/SymptomChecker/MainAssesment";

export default function BehavioralHealthAssessment() {
  const [current, setCurrent] = useState(0);
  const [showIntro, setShowIntro] = useState(true);

  const [isStep1Saved, setIsStep1Saved] = useState(false);
  const [isStep2Saved, setIsStep2Saved] = useState(false);

  const [step2NavState, setStep2NavState] = useState({
    canContinue: true,
    showWelcome: true,
    currentQuestion: 0,
    totalQuestions: 3,
  });

  const steps = [
    { title: "Personal", subtitle: "Details" },
    { title: "Mental", subtitle: "Wellbeing" },
    { title: "Summary", subtitle: "Insights" },
    { title: "Your", subtitle: "Results" },
  ];

  /* ---------------- Progress ---------------- */
  const progressPercent = (current + 1) * 25;

  /* ---------------- Navigation ---------------- */
  const handleBegin = () => {
    if (current === 0) setShowIntro(false);
    if (current === 1 && window.step2Methods) {
      window.step2Methods.handleStart();
    }
  };

  const next = () => {
    if (current === 0 && !showIntro) {
      setIsStep1Saved(true);
      setCurrent(1);
    } else if (current === 1) {
      window.step2Methods?.handleContinue();
    } else {
      setCurrent((prev) => prev + 1);
    }
  };

  const prev = () => {
    if (current === 0 && !showIntro) {
      setShowIntro(true);
    } else if (current === 1) {
      window.step2Methods?.handlePrevious();
    } else if (current > 0) {
      setCurrent((prev) => prev - 1);
    }
  };

  const getStepStatus = (index) => {
    if (index < current) return "complete";
    if (index === current) return "current";
    return "upcoming";
  };

  /* ---------------- Render ---------------- */
  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-5xl mx-auto">
        {/* Title */}
        <h2
          className="text-3xl md:text-4xl font-bold text-center mb-12"
          style={{ color: "#132573" }}
        >
          Behavioral Health Assessment
        </h2>

        {/* Stepper */}
        {/* <div className="mb-10"> */}
          {/* <div className="flex justify-between">
            {steps.map((step, index) => {
              const status = getStepStatus(index);
              return (
                <div key={index} className="flex flex-col items-center flex-1">
                  <div
                    className={`w-12 h-12 rounded-full flex items-center justify-center font-semibold mb-2 ${
                      status === "complete"
                        ? "bg-green-500 text-white"
                        : status === "current"
                        ? "bg-blue-600 text-white ring-4 ring-blue-200"
                        : "bg-gray-300 text-gray-600"
                    }`}
                  >
                    {status === "complete" ? "✓" : index + 1}
                  </div>
                  <div className="text-xs md:text-sm text-center">
                    <div className="font-semibold">{step.title}</div>
                    <div>{step.subtitle}</div>
                  </div>
                </div>
              );
            })}
          </div> */}

          {/* <div className="mt-4 text-center font-semibold">
            {progressPercent}% Complete
          </div>
          <div className="w-full bg-gray-200 rounded-full h-3 mt-2">
            <div
              className="h-full rounded-full transition-all"
              style={{
                width: `${progressPercent}%`,
                background:
                  "linear-gradient(90deg, #132573 0%, #3b82f6 100%)",
              }}
            />
          </div>
        </div> */}

        {/* Content */}
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-24">
          {/* Step 1 Intro */}
          {current === 0 && showIntro && (
            <div className="text-center max-w-2xl mx-auto">
              <h3 className="text-2xl font-bold mb-4" style={{ color: "#132573" }}>
                Let’s start with some basic information
              </h3>
              <p className="text-gray-700">
                This assessment helps us understand your emotional and behavioral
                wellbeing so we can offer relevant insights and guidance.
              </p>
            </div>
          )}

          {/* Step 1 */}
          {/* {current === 0 && !showIntro && (
            <StepOne onSave={() => setIsStep1Saved(true)} />
          )} */}

          {current === 0 && <ResultsDetail />}

          {/* Step 2 */}
          {current === 1 && (
            <StepTwo
              onComplete={(answers) => {
                setIsStep2Saved(true);
                console.log("Behavioral Answers:", answers);
                setCurrent(2);
              }}
              onNavigationStateChange={setStep2NavState}
            />
          )}

          {/* Step 3 – Summary */}
          {current === 2 && (
            <div className="text-center max-w-3xl mx-auto">
              <h3 className="text-2xl font-bold mb-6" style={{ color: "#132573" }}>
                Your Assessment Summary
              </h3>
              <p className="text-gray-700 text-lg">
                Based on your responses, we’ve identified patterns that may be
                influencing your emotional wellbeing. These insights are meant
                to help you better understand your mental health.
              </p>
            </div>
          )}

          {/* Step 4 – Results */}
          {current === 3 && <ResultsDetail />}
        </div>

        {/* Footer Navigation */}
        <div className="fixed bottom-0 left-0 right-0 bg-white border-t shadow-lg py-4">
          <div className="max-w-5xl mx-auto flex justify-between px-4">
            <button
              onClick={prev}
              disabled={current === 0 && showIntro}
              className="px-6 py-3 rounded-lg border-2 font-semibold"
              style={{ borderColor: "#132573", color: "#132573" }}
            >
              Previous
            </button>

            <button
              onClick={current === 3 ? undefined : next}
              className="px-6 py-3 rounded-lg font-semibold text-white"
              style={{ backgroundColor: "#132573" }}
            >
              {current === 3 ? "Done" : "Continue"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
